import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'
import { endOfDay, startOfDay } from 'date-fns'
import { useTranslation } from 'react-i18next'
import {
  DateRangePeriod2,
  FilterSidebar,
  FilterSidebarItem,
  dateRangePicker2PeriodCombinations,
  DateRangePicker2,
  type IDateRange2,
} from '@floriday/floriday-ui'
import { mapTransactionTypeLabel } from '../../utils/transactionTypeMapper'
import { transactionFilterTypeOptions } from '../../utils/transactionFilterUtils'
import { useTransactionFilters } from '../../context/transactionFilterContext'

const getDefaultDateRange = (): IDateRange2 => {
  const now = new Date()
  return {
    period: DateRangePeriod2.Day,
    selected: now,
    from: startOfDay(now),
    to: endOfDay(now),
  }
}

export const TransactionFilterSidebar = () => {
  const { t } = useTranslation()
  const {
    isFilterSidebarOpen,
    closeFilterSidebar,
    filterCount,
    clearFilters,
    selectedTransactionTypes,
    toggleTransactionType,
    dateFilter,
    setDateFilter,
  } = useTransactionFilters()

  return (
    <FilterSidebar
      open={isFilterSidebarOpen}
      onClose={closeFilterSidebar}
      filterCount={filterCount}
      onClearFilters={clearFilters}
    >
      <FilterSidebarItem label={t('transactions.filters.type')}>
        <FormGroup>
          {transactionFilterTypeOptions.map(transactionType => (
            <FormControlLabel
              key={transactionType}
              control={
                <Checkbox
                  checked={selectedTransactionTypes.includes(transactionType)}
                  onChange={() => toggleTransactionType(transactionType)}
                />
              }
              label={mapTransactionTypeLabel(transactionType, t)}
            />
          ))}
        </FormGroup>
      </FilterSidebarItem>
      <FilterSidebarItem label={t('transactions.filters.date')}>
        <DateRangePicker2
          {...(dateFilter ?? getDefaultDateRange())}
          periodOptions={dateRangePicker2PeriodCombinations.standard}
          onChange={range => setDateFilter(range)}
          fullWidth
        />
      </FilterSidebarItem>
    </FilterSidebar>
  )
}
